import { inject } from '@angular/core';
import type { Routes } from '@angular/router';

import { TELLENT_SUITE_ENABLED } from '@core/tellent-types';
import type { DialogConfigOptions } from '@core/user-interface-legacy';
import { DialogWidth } from '@core/user-interface-legacy';
import { protectedControlsGuardFn } from '@core/user-interface-routing-logic';

import { CurrentUserProfileDialogComponent } from './current-user-profile-dialog.component';

export const CurrentUserProfileRoutes: Routes = [
  {
    path: 'edit-profile',
    outlet: 'dialog',
    component: CurrentUserProfileDialogComponent,
    canMatch: [() => inject(TELLENT_SUITE_ENABLED)],
    canDeactivate: [protectedControlsGuardFn],
    data: {
      options: <DialogConfigOptions>{
        width: DialogWidth.Small,
        containerOptions: { fullscreenOnMobile: true },
      },
    },
  },
];
